import { Clock, DollarSign, ExternalLink, Gauge, Bot } from "lucide-react";

const diffColor = {
  "Muy fácil": "bg-emerald-100 text-emerald-800",
  "Fácil": "bg-emerald-100 text-emerald-800",
  "Media": "bg-amber-100 text-amber-800",
};

export const ToolCard = ({ tool, index }) => {
  return (
    <div
      className="bg-card border border-border rounded-2xl p-6 shadow-sm hover:shadow-md transition-all flex flex-col animate-fade-up"
      style={{ animationDelay: `${index * 0.06}s` }}
      data-testid={`tool-card-${index}`}
    >
      <div className="flex items-start justify-between gap-3 mb-3">
        <div>
          <h4 className="font-heading font-semibold text-lg leading-tight">{tool.name}</h4>
          <p className="text-xs text-muted-foreground mt-0.5">de {tool.provider}</p>
        </div>
        <span
          className={`text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap ${
            diffColor[tool.difficulty] || "bg-secondary text-primary"
          }`}
        >
          {tool.difficulty}
        </span>
      </div>

      {tool.autonomous && (
        <span
          className="inline-flex items-center gap-1.5 self-start text-xs font-semibold bg-accent/15 text-accent px-2.5 py-1 rounded-full mb-3"
          data-testid={`tool-autonomous-${index}`}
        >
          <Bot className="h-3.5 w-3.5" /> Funciona sola (IA)
        </span>
      )}

      <p className="text-sm text-muted-foreground leading-relaxed mb-5">{tool.tagline}</p>

      <div className="grid grid-cols-2 gap-3 mb-5">
        <div className="rounded-xl bg-secondary/60 p-3">
          <span className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <Clock className="h-3.5 w-3.5" /> Tiempo ahorrado
          </span>
          <p className="font-heading font-bold text-lg mt-1">{tool.timeSavedPerWeek} hrs/sem</p>
        </div>
        <div className="rounded-xl bg-secondary/60 p-3">
          <span className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <DollarSign className="h-3.5 w-3.5" /> Costo
          </span>
          <p className="font-heading font-bold text-lg mt-1">
            {tool.monthlyCost === 0 ? "Gratis" : `$${tool.monthlyCost}/mes`}
          </p>
        </div>
      </div>

      {tool.autonomyNote && (
        <p className="text-xs text-muted-foreground/90 bg-secondary/40 rounded-lg p-3 mb-4 leading-relaxed">
          <span className="font-semibold text-foreground">Cómo trabaja la IA:</span>{" "}
          {tool.autonomyNote}
        </p>
      )}

      <div className="flex items-center gap-1.5 text-xs text-muted-foreground mb-5">
        <Gauge className="h-3.5 w-3.5" /> Se configura en unos {tool.setupMinutes} minutos
      </div>

      <a
        href={tool.url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`tool-link-${index}`}
        className="mt-auto inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground px-4 py-2.5 rounded-full text-sm font-semibold hover:bg-primary/90 transition-colors"
      >
        Abrir {tool.provider} <ExternalLink className="h-4 w-4" />
      </a>
    </div>
  );
};
